module.exports = __webpack_public_path__ + "media/A42.b82525f6.mp3";